import { ContentModuleStyle } from '@silvertours/common-landingpages-view';
import { Ui } from '@silvertours/front-shared';

export const SectionTitleStyle: Record<string, Ui.SectionTitleType> = {
  default: 'default',
  gray: 'default',
  green: 'brand-green',
  mint: 'brand-green',
  orange: 'neutral-grey',
};

export const selectSectionTitleStyle = (
  style: ContentModuleStyle = 'default',
): Ui.SectionTitleType => SectionTitleStyle[style];
